<div class="magazine-viewer" [class.fullscreen]="isFullscreen">
  <!-- Loading State -->
  <!-- <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
    <p class="loading-text">Loading your magazine...</p>
  </div> -->

  <!-- Authentication Required State -->
  <div *ngIf="isAuthError && !isLoading" class="auth-error-container">
    <div class="auth-error-content">
      <div class="lock-icon">🔒</div>
      <h2>Authentication Required</h2>
      <p>{{ error }}</p>
      <p class="redirect-message">Redirecting you to login page...</p>
      <div class="auth-buttons">
        <button class="btn-primary" (click)="router.navigate(['/login'], { queryParams: { returnUrl: '/gazeti-magazine/' + gazetiUuid } })">
          Go to Login Now
        </button>
        <button class="btn-secondary" (click)="closeViewer()">
          Back to Home
        </button>
      </div>
    </div>
  </div>

  <!-- Error State (Non-Auth Errors) -->
  <div *ngIf="error && !isLoading && !isAuthError" class="error-container">
    <div class="error-content">
      <h2>Oops!</h2>
      <p>{{ error }}</p>
      <button class="btn-primary" (click)="closeViewer()">Go Back</button>
    </div>
  </div>

  <!-- Magazine Viewer -->
  <div *ngIf="!isLoading && !error" class="viewer-container">
    <!-- Top Toolbar -->
    <div class="toolbar">
      <div class="toolbar-left">
        <button class="tool-btn" (click)="closeViewer()" title="Close">
          <hugeicons-icon
            [icon]="icons.close"
            [size]="20"
            color="currentColor"
            [strokeWidth]="2"
          ></hugeicons-icon>
        </button>
        <h3 style="margin: 0; font-size: 18px; color: white;">Tanzania Standard Newspapers</h3>
      </div>

      <div class="toolbar-center">
        <span class="page-indicator">
          Page {{ currentPageIndex + 1 }} of {{ pages.length }}
        </span>
      </div>

      <div class="toolbar-right">
        <button class="tool-btn" (click)="toggleThumbnails()" title="Thumbnails">
          <hugeicons-icon
            [icon]="icons.menu"
            [size]="20"
            color="currentColor"
            [strokeWidth]="2"
          ></hugeicons-icon>
        </button>
        <button class="tool-btn" (click)="zoomOut()" title="Zoom Out">
          <hugeicons-icon
            [icon]="icons.zoomOut"
            [size]="20"
            color="currentColor"
            [strokeWidth]="2"
          ></hugeicons-icon>
        </button>
        <button class="tool-btn" (click)="zoomIn()" title="Zoom In">
          <hugeicons-icon
            [icon]="icons.zoomIn"
            [size]="20"
            color="currentColor"
            [strokeWidth]="2"
          ></hugeicons-icon>
        </button>
        <button class="tool-btn" (click)="toggleFullscreen()" title="Fullscreen">
          <hugeicons-icon
            [icon]="icons.fullscreen"
            [size]="20"
            color="currentColor"
            [strokeWidth]="2"
          ></hugeicons-icon>
        </button>
      </div>
    </div>

    <!-- Magazine Book Container -->
    <div class="book-container" [style.transform]="'scale(' + zoomLevel + ')'">
      <div class="book-wrapper">
        <!-- Magazine Spine/Shadow -->
        <div class="book-spine"></div>

        <!-- Left Page -->
        <div 
          class="page left-page"
          [class.flipping]="isFlipping && flipDirection === 'left'"
          [class.hidden]="currentPageIndex === 0"
        >
          <div class="page-content">
            <ng-container *ngIf="currentPage && currentPageIndex > 0">
              <ng-container *ngIf="pages[currentPageIndex - 1]">
                <div class="article-container" *ngIf="pages[currentPageIndex - 1].isDoublePage && pages[currentPageIndex - 1].rightArticle">
                  <ng-container *ngTemplateOutlet="articleTemplate; context: { article: pages[currentPageIndex - 1].rightArticle }"></ng-container>
                </div>
                <div class="article-container" *ngIf="!pages[currentPageIndex - 1].isDoublePage && pages[currentPageIndex - 1].article">
                  <ng-container *ngTemplateOutlet="articleTemplate; context: { article: pages[currentPageIndex - 1].article }"></ng-container>
                </div>
                <div class="cover-page" *ngIf="currentPageIndex === 1">
                  <ng-container *ngTemplateOutlet="coverTemplate"></ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="page-number">{{ currentPageIndex > 0 ? currentPageIndex : '' }}</div>
        </div>

        <!-- Right Page -->
        <div 
          class="page right-page"
          [class.flipping]="isFlipping && flipDirection === 'right'"
        >
          <div class="page-content">
            <ng-container *ngIf="currentPage">
              <!-- Cover Page -->
              <div class="cover-page" *ngIf="currentPageIndex === 0">
                <ng-container *ngTemplateOutlet="coverTemplate"></ng-container>
              </div>

              <!-- Back Cover -->
              <div class="back-cover" *ngIf="currentPageIndex === pages.length - 1">
                <ng-container *ngTemplateOutlet="backCoverTemplate"></ng-container>
              </div>

              <!-- Double Page Spread -->
              <ng-container *ngIf="currentPage.isDoublePage">
                <div class="double-spread">
                  <div class="article-container left-article">
                    <ng-container *ngTemplateOutlet="articleTemplate; context: { article: currentPage.leftArticle }"></ng-container>
                  </div>
                  <div class="spread-divider"></div>
                  <div class="article-container right-article">
                    <ng-container *ngTemplateOutlet="articleTemplate; context: { article: currentPage.rightArticle }"></ng-container>
                  </div>
                </div>
              </ng-container>

              <!-- Single Article Page -->
              <div class="article-container" *ngIf="!currentPage.isDoublePage && currentPage.article">
                <ng-container *ngTemplateOutlet="articleTemplate; context: { article: currentPage.article }"></ng-container>
              </div>
            </ng-container>
          </div>
          <div class="page-number">{{ currentPageIndex + 1 }}</div>
        </div>

        <!-- Flipping Page Animation Overlay -->
        <div class="flipping-page" *ngIf="isFlipping" [class.flip-right]="flipDirection === 'right'" [class.flip-left]="flipDirection === 'left'">
          <div class="flipping-page-front"></div>
          <div class="flipping-page-back"></div>
        </div>
      </div>
    </div>

    <!-- Navigation Controls -->
    <div class="navigation-controls">
      <button 
        class="nav-btn prev-btn" 
        (click)="previousPage()" 
        [disabled]="!canGoPrevious || isFlipping"
        title="Previous Page"
      >
        <hugeicons-icon
          [icon]="icons.arrowLeft"
          [size]="32"
          color="currentColor"
          [strokeWidth]="2"
        ></hugeicons-icon>
      </button>

      <button 
        class="nav-btn next-btn" 
        (click)="nextPage()" 
        [disabled]="!canGoNext || isFlipping"
        title="Next Page"
      >
        <hugeicons-icon
          [icon]="icons.arrowRight"
          [size]="32"
          color="currentColor"
          [strokeWidth]="2"
        ></hugeicons-icon>
      </button>
    </div>

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="pageProgress"></div>
      </div>
    </div>

    <!-- Thumbnail Sidebar -->
    <div class="thumbnail-sidebar" [class.open]="showThumbnails">
      <div class="thumbnail-header">
        <h3>All Pages</h3>
        <button class="close-thumbnails" (click)="toggleThumbnails()">
          <hugeicons-icon
            [icon]="icons.close"
            [size]="20"
            color="currentColor"
            [strokeWidth]="2"
          ></hugeicons-icon>
        </button>
      </div>
      <div class="thumbnail-grid">
        <div 
          *ngFor="let page of pages; let i = index" 
          class="thumbnail-item"
          [class.active]="i === currentPageIndex"
          (click)="goToPage(i)"
        >
          <div class="thumbnail-preview">
            <span class="thumbnail-page-number">{{ i + 1 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Article Template -->
<ng-template #articleTemplate let-article="article">
  <div class="article" *ngIf="article">
    <div class="article-image" *ngIf="article.imageUrl">
      <img [src]="article.imageUrl" [alt]="article.headline" />
    </div>
    <div class="article-header">
      <h3 class="article-headline">{{ article.headline }}</h3>
      <div class="article-meta">
        <span class="article-author">By {{ article.author }}</span>
        <span class="article-date">{{ article.publicationDate | date: 'MMM d, yyyy' }}</span>
      </div>
    </div>
    <div class="article-content" [innerHTML]="article.content"></div>
  </div>
</ng-template>

<!-- Cover Template -->
<ng-template #coverTemplate>
  <div class="cover-content">
    <div class="cover-logo">
      <h1>TANZANIA STANDARD</h1>
      <h2>NEWSPAPERS</h2>
    </div>
    <div class="cover-tagline">
      <p>Your Trusted Source for News</p>
    </div>
    <div class="cover-date">
      <p>{{ articles[0]?.publicationDate | date: 'EEEE, MMMM d, yyyy' }}</p>
    </div>
  </div>
</ng-template>

<!-- Back Cover Template -->
<ng-template #backCoverTemplate>
  <div class="back-cover-content">
    <div class="back-cover-message">
      <h3>Thank You for Reading</h3>
      <p>Stay informed with Tanzania Standard Newspapers</p>
      <div class="social-links">
        <p>Follow us on social media</p>
      </div>
    </div>
  </div>
</ng-template>